export const valueIsDecimal = function (value) {
  return /^-?(?:0|0\.\d*|[1-9]\d*\.?\d*)$/.test(value)
}

// Check the value ist a number or an authorized character
export const checkInputForNumber = function (keyEvent, withDecimalPlaces = false, language = 'en-GB') {
  const key = keyEvent.key
  // authorized character: backspace, delete, tab, escape, enter, ctrl, end, home, cursor, numlock -, -
  // let authChar = [46, 8, 9, 27, 13, 17, 35, 36, 37, 38, 39, 40, 109, 173]
  const authKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Control', 'End', 'Home', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'Left', 'Right', 'Up', 'Down']
  if (authKeys.includes(key)) {
    return true
  }

  if (key === '-' && !keyEvent.currentTarget._value.includes('-')) {
    return true
  }

  // authorized character for german: comma
  // if (withDecimalPlaces && language.substring(0, 2) === 'de' && (keyEvent.keyCode === 188 || keyEvent.keyCode === 110)) {
  if (withDecimalPlaces && language.substring(0, 2) === 'de' && key === ',') {
    if (!keyEvent.currentTarget._value.includes(',')) {
      return true
    }
  }

  // authorized character for german: point
  // if (withDecimalPlaces && language.substring(0, 2) === 'en' && (keyEvent.keyCode === 190 || keyEvent.keyCode === 110)) {
  if (withDecimalPlaces && language.substring(0, 2) === 'en' && key === '.') {
    if (!keyEvent.currentTarget._value.includes('.')) {
      return true
    }
  }

  // all other character not allowed
  if ((keyEvent.shiftKey || (keyEvent.keyCode < 48 || keyEvent.keyCode > 57)) && (keyEvent.keyCode < 96 || keyEvent.keyCode > 105)) {
    return false
  }

  return true
}

// Unmask the value in a numeric text field for editing
export const numberTextFieldValueUnMask = function (value) {
  return value.replace(',', '.')
}

// Display (mask) the value of a numeric text field with decimal places
export const numberTextFieldValueMask = function (that, value, editing = false, format = 'numberWith2DecimalGrouping') {
  if (editing) {
    const valueStr = value.toString()
    if (valueStr.charAt(0) === '.') {
      if (valueStr.length === 1) {
        value = 0
      } else {
        value = Number('0.' + valueStr.substring(1))
      }
    }
    return that.$n(value, 'number', that.$i18n.locale)
  } else {
    return that.$n(value, format, that.$i18n.locale)
  }
}

// Sort a array by a string index column
export const sortArrayByStrings = function (items, index, sortDir, language) {
  const preSort = sortDir === 'asc' ? 1 : -1
  const collator = new Intl.Collator(language)
  return items.sort((a, b) => collator.compare(a[index], b[index]) * preSort)
}

export const localizeDateString = function (that, dateString, format = 'long') {
  if (dateString === null || dateString === undefined) {
    return ''
  }
  return that.$d(new Date(dateString), format)
}

export default {
  data () {
    return {
      version: '1.0'
    }
  }
}
